// extracted by css-extract-rspack-plugin
module.exports =  {"cardv5":"HRxY5","topRow":"Jr7G4","brand_logo":"ygP0L","noLogo":"JapQt"};